module.exports = __webpack_public_path__ + "img/orange-tick.352cabe2.svg";